module.exports = __webpack_public_path__ + "img/zns.c12267d0.png";